import React from "react";
import { Modal, ModalBody, Spinner } from "reactstrap";
import "styles/components/modal/modalInfo.scss";
import classnames from "classnames";

export interface IModalInfoProps {
  isOpen: boolean;
  heading: string;
  content: string;
  toggle: () => void;
  type?: string;
  onOk?: () => any;
  okText?: string;
  cancelText?: string;
  loading?: boolean;
  className?: string;
  size?: string;
  closePopup?: boolean;
  contentHTML?: any;
  icon?: any;
  colorIcon?: string;
}

const ModalInfo: React.FC<IModalInfoProps> = ({
  isOpen,
  heading,
  content,
  toggle,
  type = "",
  onOk,
  okText,
  cancelText,
  loading,
  className,
  size = "md",
  closePopup = true,
  contentHTML = () => <></>,
  icon,
  colorIcon = "",
}: IModalInfoProps) => {
  const renderNonActionBtn = (): React.ReactNode => {
    if (type === "reload")
      return (
        <button className="button button--blue" data-testid="i-understand" onClick={onOk}>
          {okText}
        </button>
      );
    return (
      <button className="button button--blue" data-testid="i-understand" onClick={toggle}>
        {type === "text" ? okText : "I understand"}
      </button>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={closePopup ? toggle : () => {}}
      className={
        className
          ? `modal-dialog-centered modal-info ${className}`
          : "modal-dialog-centered modal-info"
      }
      size={size}>
      <ModalBody>
        <p className="modal-info__heading">
          {icon && (
            <span className={classnames("modal-info__heading--icon", colorIcon)}>{icon}</span>
          )}
          {heading}
        </p>
        <p className="modal-info__text">{content}</p>
        {!content && <div className="modal-info__text mb-3">{contentHTML()}</div>}
        <div className="modal-info__bottom">
          {type === "action" ? (
            <>
              <button className="button-link button-link--grey button-left" onClick={toggle}>
                {cancelText}
              </button>
              {!loading ? (
                <button className="button button--blue button-right" onClick={onOk}>
                  {okText}
                </button>
              ) : (
                <button className="button button--blue">
                  <Spinner color="primary" size="sm" />
                </button>
              )}
            </>
          ) : (
            renderNonActionBtn()
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalInfo;
